<template>
  <div>
    <div class="row">
      <div class="col-auto">
        <img
          class="thumb-lg"
          :src="item.thumbnail"
        >
      </div>
      <div class="col">
        <div><strong>Color</strong></div>
        <div>
          <select
            id="color"
            v-model="data.current_color"
            class="form-control"
            name="color"
          >
            <option
              v-for="(x, id) in data.color"
              :key="id"
              :value="id"
            >
              {{ x }}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <div><strong>Size</strong></div>
        <div>
          <select
            id="size"
            v-model="data.current_size"
            class="form-control"
            name="size"
          >
            <template v-for="(x, id) in data.size">
              <option
                :key="id"
                :value="id"
              >
                {{ x }}
              </option>
            </template>
          </select>
        </div>
      </div>
    </div>
    <hr>
    <button
      class="btn btn-success float-right"
      @click="save"
    >
      Save
    </button>
    <button
      class="btn btn-light float-right mr-3"
      @click="hiddenModal"
    >
      Close
    </button>
  </div>
</template>

<script>
    export default {
        name: "OrderEditItem",
        props: ['item'],
        data: function () {
            return {
                data: {}
            }
        },
        watch: {
            'item.id': function () {
                this.setting()
            }
        },
        methods: {
            hiddenModal: function () {
                this.$root.$emit('bv::hide::modal', 'refEditItem')
            },
            setting: function () {
                let vm = this
                this.$http.get(this.$config.api + 'order/item/' + vm.item.id).then(function (res) {
                    vm.data = res.data
                })
            },
            save: function () {
                let vm = this
                let post = {
                    id: vm.item.id,
                    id_color: vm.data.current_color,
                    id_size: vm.data.current_size,
                    color: vm.data.color[vm.data.current_color],
                    size: vm.data.size[vm.data.current_size]
                }
                this.$http.post(this.$config.api + 'order/item', post).then(function (res) {
                    vm.$emit('update', vm.item.id)
                    vm.$root.$emit('bv::hide::modal', 'refEditItem')
                })
            }
        }

    }
</script>

<style scoped>

</style>